import { makeAutoObservable } from "mobx";
import { Availability } from "../Availability";
import { Email } from "../Email";
/**
 * Contact details needed for a QRWaiter order.
 */
export class QrWaiterContactDetails {
    constructor(params) {
        this.type = "QRWaiter";
        this.contactDetailsLock = params.contactDetailsLock;
        this._email = params.email;
        makeAutoObservable(this);
    }
    static empty(contactDetailsLock) {
        return new QrWaiterContactDetails({
            contactDetailsLock,
            email: Email.Empty,
        });
    }
    static fromStorageData(contactDetailsLock, storageData) {
        return new QrWaiterContactDetails({
            contactDetailsLock,
            email: Email.create(storageData.email),
        });
    }
    setData(data) {
        if (this.locked)
            return;
        if (data.email !== undefined) {
            this.email = data.email;
        }
    }
    set email(value) {
        if (this.locked) {
            throw Error("Can't change email, ContactDetails locked");
        }
        this._email = value;
    }
    get email() {
        return this._email;
    }
    get fullName() {
        throw new Error("Can't access fullName at QRWaiterContactDetails");
    }
    set fullName(_) {
        throw new Error("Can't set fullName at QRWaiterContactDetails");
    }
    get phone() {
        throw new Error("Can't access phone at QRWaiterContactDetails");
    }
    set phone(_) {
        throw new Error("Can't set phone at QRWaiterContactDetails");
    }
    setPhone(_) {
        throw new Error("Can't set phone at QRWaiterContactDetails");
    }
    get locked() {
        return this.contactDetailsLock.locked;
    }
    unlock() {
        this.contactDetailsLock.unlock();
    }
    get availability() {
        return Availability.composite([this.email.availability]);
    }
    get storageData() {
        return {
            type: "QRWaiter",
            email: this.email.value,
        };
    }
}
